import { useQuery } from '@tanstack/react-query';
import { getContactNotesApi } from 'services/contact-notes/getContactNotesApi';

export const getContactNotesQueryKey = (serviceAgreementId: string | undefined) =>
  ['contactNotes', serviceAgreementId] as const;

export const useGetContactNotes = (serviceAgreementId: string | undefined) => {
  return useQuery({
    queryKey: getContactNotesQueryKey(serviceAgreementId),
    queryFn: () => {
      if (!serviceAgreementId) {
        return Promise.resolve([]);
      }

      return getContactNotesApi(serviceAgreementId);
    },
    enabled: !!serviceAgreementId,
  });
};
